import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactInfo = ({ className = "" }) => {
  const contactDetails = [
    {
      id: 1,
      title: "Project Coordinator",
      name: "Lucija Vasiljevic",
      organization: "Regionalna agencija za prostorni i ekonomski razvoj Raškog i Moravičkog okruga",
      email: "lucija.vasiljevic@kv-rda.org",
      phone: "+381 36 397 770, 397 777",
      phone2: "+381 65 602 42 91",
      website: "www.kv-rda.org",
      hours: "Monday - Friday: 8:00 AM - 4:00 PM CET"
    }
  ];

  const contactMethods = [
    {
      type: "General Information",
      email: "info@creative-twinning.com",
      description: "For general inquiries and project information",
      icon: "Info"
    },
    {
      type: "Partnership Opportunities",
      email: "lucija.vasiljevic@kv-rda.org", 
      description: "For collaboration and partnership inquiries",
      icon: "Handshake"
    }
  ];

  return (
    <div className={`space-y-8 ${className}`}>
      {/* Main Contact Information */}
      <div className="bg-card rounded-lg shadow-card p-6 lg:p-8">
        <div className="mb-6">
          <h2 className="font-heading font-semibold text-xl text-foreground mb-2">
            Contact Information
          </h2>
          <p className="text-muted-foreground">
            Get in touch with our project coordinator for detailed information and partnership opportunities.
          </p>
        </div>

        {contactDetails?.map((contact) => (
          <div key={contact?.id} className="space-y-6">
            <div className="border-l-4 border-primary pl-4">
              <h3 className="font-heading font-semibold text-lg text-foreground">
                {contact?.title}
              </h3>
              <p className="text-accent font-medium">{contact?.name}</p>
              <p className="text-sm text-muted-foreground leading-relaxed">{contact?.organization}</p>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <Icon name="Mail" size={18} className="text-muted-foreground flex-shrink-0" />
                <a 
                  href={`mailto:${contact?.email}`}
                  className="text-primary hover:text-primary/80 transition-colors text-sm"
                >
                  {contact?.email}
                </a>
              </div>

              <div className="flex items-center gap-3">
                <Icon name="Phone" size={18} className="text-muted-foreground flex-shrink-0" />
                <div className="space-y-1">
                  <a 
                    href={`tel:${contact?.phone?.replace(/[,\s]/g, '')}`}
                    className="block text-primary hover:text-primary/80 transition-colors text-sm"
                  >
                    {contact?.phone}
                  </a>
                  <a 
                    href={`tel:${contact?.phone2}`}
                    className="block text-primary hover:text-primary/80 transition-colors text-sm"
                  >
                    {contact?.phone2}
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <Icon name="Globe" size={18} className="text-muted-foreground flex-shrink-0" />
                <a 
                  href={`https://${contact?.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:text-primary/80 transition-colors text-sm"
                >
                  {contact?.website}
                </a>
              </div>

              <div className="flex items-center gap-3">
                <Icon name="Clock" size={18} className="text-muted-foreground flex-shrink-0" />
                <p className="text-sm text-muted-foreground">{contact?.hours}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Quick Contact Options */}
      <div className="bg-card rounded-lg shadow-card p-6 lg:p-8">
        <div className="mb-6">
          <h2 className="font-heading font-semibold text-xl text-foreground mb-2">
            Quick Contact
          </h2>
          <p className="text-muted-foreground">
            Choose the appropriate contact method for your specific needs.
          </p>
        </div>

        <div className="space-y-4">
          {contactMethods?.map((contact, index) => (
            <div key={index} className="flex items-start gap-4 p-4 border border-border rounded-lg hover:shadow-sm transition-shadow">
              <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name={contact?.icon} size={20} className="text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-foreground mb-1">{contact?.type}</h3>
                <p className="text-sm text-muted-foreground mb-2">{contact?.description}</p>
                <a 
                  href={`mailto:${contact?.email}`}
                  className="text-sm text-primary hover:text-primary/80 transition-colors"
                >
                  {contact?.email}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Partnership Opportunities */}
      <div className="bg-card rounded-lg shadow-card p-6 lg:p-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Handshake" size={32} className="text-accent" />
          </div>
          <h2 className="font-heading font-semibold text-xl text-foreground mb-4">
            Become a Partner
          </h2>
          <p className="text-muted-foreground mb-6">
            Join our network of partners committed to promoting cross-border heritage tourism and cultural exchange. We welcome collaboration from tourism operators, cultural institutions, and government organizations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="default" 
              size="lg"
              onClick={() => window.location.href = `mailto:${contactDetails?.[0]?.email}?subject=Partnership Inquiry`}
            >
              <Icon name="Mail" size={18} className="mr-2" />
              Partnership Inquiry
            </Button>
            <Button variant="outline" size="lg">
              <Icon name="Download" size={18} className="mr-2" />
              Partnership Guidelines
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;